import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = { // 要设置的全局访问的state对象
    islogin: false,
    userId: '',
    userName: '',
    companyName: '',
    cooperationType: '', // null、0未合作，1发货方，2承运方
    iMemberType: ''

};
const getters = { // 实时监听state值的变化(最新状态)
    getUser(state) {
        return state.islogin
    }
};

function setCookie(name, value, seconds) {
    seconds = seconds || 0; // seconds有值就直接赋值，没有为0
    var expires = '';
    if (seconds != 0) { // 设置cookie生存时间
        var date = new Date();
        date.setTime(date.getTime() + (seconds * 1000));
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + escape(value) + expires + '; path=/'; // 转码并赋值
};
const mutations = {
    set_user(state, res) { // 自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
        console.log(res)
        debugger
        state.islogin = true;
        state.userId = res.userId;
        state.userName = res.userName;
        state.companyName = res.companyName;
        state.cooperationType = res.cooperationType;
        state.iMemberType = res.iMemberType;
        localStorage.setItem('islogin', true);
        localStorage.setItem('userId', res.userId);
        localStorage.setItem('userName', res.userName);
        localStorage.setItem('userphone', res.nvcPhone);
        localStorage.setItem('companyName', res.companyName);
        localStorage.setItem('cooperationType', res.cooperationType);
        localStorage.setItem('iMemberType', res.iMemberType);
        setCookie('islogin', true)
    },
    del_user(state) { // 自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
        state.islogin = false;
        state.userId = '';
        state.userName = '';
        state.companyName = '';
        state.cooperationType = '';
        state.iMemberType = '';
        localStorage.setItem('islogin', false);
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('userphone');
        localStorage.removeItem('companyName');
        localStorage.removeItem('cooperationType');
        localStorage.removeItem('iMemberType');
    }

};
const actions = {
    change_user(context, res) { // 自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
        debugger;
        context.commit('set_user', res);
    },
    delete_user(context) {
        context.commit('del_user');
    }
};
const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});

export default store;


// WEBPACK FOOTER //
// ./src/assets/store.js